var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearMoonLm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3051 33.4133C37.8179 32.8934 37.3224 32.0679 36.5879 32.1237C36.1422 32.1576 35.6919 32.1749 35.2374 32.1749C25.6959 32.1749 17.9611 24.5713 17.9611 15.1918C17.9611 12.307 18.6928 9.59015 19.9837 7.21087C20.3309 6.57087 19.7586 5.79349 19.0686 6.05037C12.6363 8.4448 8.0625 14.5646 8.0625 21.7362C8.0625 30.9946 15.6854 38.5 25.0888 38.5C29.8811 38.5 34.211 36.5506 37.3051 33.4133Z",
    fill: "#A3B6C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearMoonLm);
export default __webpack_public_path__ + "static/media/clear-moon-lm.5ed9c1ba412a735a835c8cd84a0de6e7.svg";
export { ForwardRef as ReactComponent };